export const stripeDashboardLink: string = import.meta.env
  .VITE_APP_STRIPE_DASHBOARD_LINK
